import * as React from 'react';
import type { SkyLayer } from 'react-map-gl';
import Map, { Layer, MapRef, Point } from 'react-map-gl';

import clsx from 'clsx';
import 'mapbox-gl/dist/mapbox-gl.css';

const TOKEN = process.env.NEXT_PUBLIC_MAPBOX_TOKEN;

const skyLayer: SkyLayer = {
  id: 'sky',
  type: 'sky',
  paint: {
    'sky-type': 'atmosphere',
    'sky-atmosphere-sun': [0.0, 0.0],
    'sky-atmosphere-sun-intensity': 15,
  },
};

const settings3D = {
  // mapStyle: 'mapbox://styles/mapbox/satellite-streets-v12',
  // mapStyle: 'mapbox://styles/mapbox-map-design/ckhqrf2tz0dt119ny6azh975y',

  mapStyle: 'mapbox://styles/mapbox/streets-v9',
  terrain: { source: 'mapbox-dem', exaggeration: 1.5 },
};

interface MapProps {
  className?: string;
  center?: Point;
  activated3D?: boolean;
  theme?: 'light' | 'dark';
  onMap?: (map: MapRef) => void;
}
const Map3D = ({
  children,
  className,
  center,
  activated3D,
  theme = 'light',
  onMap,
}: React.PropsWithChildren<MapProps>) => {
  const mapRef = React.useRef(null);

  const settings3D = React.useMemo(() => {
    return {
      mapStyle: theme === 'light' ? 'mapbox://styles/mapbox/streets-v9' : 'mapbox://styles/mapbox/dark-v10',
      terrain: { source: 'mapbox-dem', exaggeration: 1.5 },
    };
  }, [theme]);

  const mapStyle = React.useMemo(() => {
    if (activated3D) return settings3D.mapStyle;

    if (theme === 'dark') {
      return 'mapbox://styles/mapbox/dark-v10?optimize=true';
    }
    return 'mapbox://styles/mapbox/streets-v9?optimize=true';
  }, [activated3D, settings3D.mapStyle, theme]);

  const onMapLoad = React.useCallback(() => {
    onMap?.(mapRef.current as any);
  }, [onMap]);

  return (
    <div className={clsx('h-full w-full', className)}>
      <Map
        ref={mapRef}
        onLoad={onMapLoad}
        mapboxAccessToken={TOKEN}
        initialViewState={{
          latitude: center ? center.y : 39.5242328,
          longitude: center ? center.x : 15.9209716,
        }}
        scrollZoom={false}
        maxPitch={85}
        mapStyle={mapStyle}
        // terrain={activated3D ? settings3D.terrain : undefined}
      >
        {/* <Source
          id="mapbox-dem"
          type="raster-dem"
          url="mapbox://mapbox.mapbox-terrain-dem-v1"
          tileSize={512}
          maxzoom={14}
        />
      */}
        <Layer {...skyLayer} />
        {children}
      </Map>
    </div>
  );
};

export default React.memo(Map3D);
